import { color } from "@/constants/palette";
import React from "react";

/**
 * * 화면 1, 히어로.
 *
 * 우주 컨셉: 우상단 북극성(길잡이) → 좌하단 코딩이가 그것을 올려다보는 구도.
 * 장식(별·궤도·유도선)은 전부 aria-hidden 이고 위치는 CSS 가 잡습니다.
 */
export default function LandingHero({ onApplyOpen }: { onApplyOpen: () => void }) {
  return (
    <section className="hero" id="contact">
      <div className="space-decor" aria-hidden="true">
        {/*
          코딩이 → 북극성 안내선. 좁은 화면에서는 북극성이 더 오른쪽으로 가므로
          끝점도 같이 옮깁니다. line 의 x1/y1 은 SVG2 geometry property 가 아니라
          CSS 로 못 바꿔서, 선을 두 벌 두고 미디어 쿼리로 토글합니다.
        */}
        <svg className="guide-path" viewBox="0 0 100 100" preserveAspectRatio="none">
          <line className="guide-wide" x1="72" y1="16" x2="11" y2="82" vectorEffect="non-scaling-stroke" />
          <line className="guide-narrow" x1="84" y1="16" x2="24" y2="84" vectorEffect="non-scaling-stroke" />
        </svg>
        <div className="orbit o1">
          <span className="planet" />
        </div>
        <div className="north-star">
          <span className="halo" />
          <svg viewBox="0 0 24 24">
            <path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z" fill={color.primarySoft} />
          </svg>
        </div>
        <span className="deco d1" />
        <span className="deco d2" />
        <span className="deco d3" />
      </div>

      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className="hero-char"
        src="/images/landing/coding-e.png"
        alt=""
        aria-hidden="true"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />

      <div className="shell hero-grid">
        <div className="hero-copy">
          <h1 className="t-display">
            시대는 바뀌었는데,
            <br />
            <span className="accent">
              진로검사는 그대로<span className="plain">입니다.</span>
            </span>
          </h1>
          <p className="t-body hero-body">
            지금까지의 검사가 알려준 직업은 곧 사라질지 모릅니다.
            <br />
            논·서술형 검사로 아이의 미래 강점을 분석해,
            <br />
            새로운 진로 탐색을 시작하세요.
          </p>
        </div>

        <div className="hero-cta">
          <button type="button" className="btn-hero" onClick={onApplyOpen}>
            체험 계정 신청하기
          </button>
          <p className="hero-cta-note">영업일 기준 3일 이내에 담당자가 연락드립니다.</p>
          {/* 브랜드 전환 안내. 구 이름(디큐)으로 찾아온 사용자와 검색엔진·AI 답변 엔진이 같은 서비스임을 알게 한다. */}
          <p className="hero-cta-note hero-rename">
            디큐(DQ)가 <strong>해봄</strong>으로 이름을 바꿨습니다. 길잡이별 검사와 학습 기록은 그대로예요.
          </p>
        </div>
      </div>
    </section>
  );
}
